const TextStrings = {
    'CRIAR_CONTA_GIRO': 'Create a Giro account',
    'RECUPECAO_SENHA_GIRO': 'Giro password recovery',
    'INGLES':'Inglês',
    'PORTUGUES':'Português',
    'RECUPERAR': 'recover',
    'CRIAR_CONTA': 'create account',
    'ESQUECI_MINHA_SENHA': 'I forgot my password',
    'ENTRAR_COM_GOOGLE': 'sign in with google',
    'OU': 'or',
    'CONFIRMAR': 'confirm',
    'CONTINUAR': 'continue',
    'TERMOS_CONDICOES': 'Terms and usage statement',
    'TERMOS_DE_USO': 'Terms and conditions of use',
    'ACOMPANHAR_PEDIDO': 'To track your order status, return to the Giro - Metro Rio app',
    'DECLARACAO_PRIVACIDADE': 'Privacy statement',
    'FECHAR': 'close',
    'COPYRIGHT': `\u00A9 Copyright MetroRio {0}. All rights reserved.`,
    'RECARGA_NAO_EFETUADA': '"Recharge not completed"',
    'RECARGA': 'recharge',
    'VANTAGENS': 'advantages',
    'EXTRATO': 'extract',
    'MEUS_DADOS': 'my data',
    'AJUDA': 'help',
    'SAIR': 'logout',
    'MENSAGEM': 'message',
    'ELOGIO': 'compliment',
    'CRITICA': 'criticism',
    'INFORMACAO': 'information',
    'SUGESTAO': 'suggestion',
    'ASSUNTO': 'subject',
    'ESCOLHA_POR_CATEGORIA': 'Browse by category',
    'DESTAQUE': 'Featured',
    'VOLTAR': 'Back',
    'NENHUM_PARCEIRO_CATEGORIA': 'No partners in this category',
    'CARREGANDO': 'Loading...',
    'IR_PARA_CATEGORIA': 'Go to category',
    'QUERO_SER_INFORMADO_NOVIDADES': 'I want to receive MetroRio promotions and news by email',
    'BEMVINDO': 'Welcome',
    'BEMVINDO_USUARIO': 'Welcome, {0}!',
    'CARTAO': 'Card: {0}',
    'SALDO_NO_CARTAO': 'Card balance:',
    'SALDO_NO_CARTAO_INFO': 'Balance available for use at MetroRio. Validate pending credits at station validation terminals.',
    'CREDITOS_PROMOCIONAIS': 'Promotional credits:',
    'CREDITOS_PROMOCIONAIS_INFO': 'Promotional credit available for use at MetroRio. The credit is updated after recharge payment confirmation.',
    'SALDO_VALIDAR': 'Balance to validate:',
    'SALDO_VALIDAR_INFO': 'Validate your credits directly at the turnstile of any MetroRio station.',
    'PASSAGENS': 'Tickets',
    'ESCOLHA_QTD_PASSAGENS': 'Choose the desired number of tickets',
    'INSIRA_VALOR_RECARGA': 'Or enter the desired recharge amount',
    'VALOR_TOTAL': 'Total Amount',
    'CADASTRE_SEU_CUPOM': 'Register your coupon',
    'NR_PASSAGENS': 'No. of tickets',
    'FORMA_DE_PAGAMENTO': 'Payment Method',
    'NO_VALOR_DE': 'Amounting to {0}',
    'PAGAMENTO': 'Payment',
    'ESCOLHA_SEU_CARTAO': 'Choose your card',
    'NOVO_CARTAO': 'New card',
    'RECARREGAR': 'recharge',
    'VIAGENS': 'Trips',
    'RECARGA_M': 'Recharge',
    'ENVIAR': 'send',
    'MENSAGEM_ENVIADA_SUCESSO': 'Message sent successfully!',
    'AGUARDE': 'wait...',
    'BLOQUEAR': 'block',
    'TODOS': 'All',
    'DE': 'From',
    'A': 'to',
    'IR': 'go',
    'DIA': 'Day',
    'MES': 'Month',
    'ANO': 'Year',
    'JANEIRO': 'January',
    'FEVEREIRO': 'February',
    'MARCO': 'March',
    'ABRIL': 'April',
    'MAIO': 'May',
    'JUNHO': 'June',
    'JULHO': 'July',
    'AGOSTO': 'August',
    'SETEMBRO': 'September',
    'OUTUBRO': 'October',
    'NOVEMBRO': 'November',
    'DEZEMBRO': 'December',
    'DADOS_CADASTRAIS': 'registration data',
    'ALTERAR_SENHA': 'change password',
    'SENHA_ATUAL': 'current password',
    'NOVA_SENHA': 'new password',
    'CONFIRMACAO_NOVA_SENHA': 'new password confirmation',
    'CADASTRO_USUARIO': 'User registration',
    'NAO_EXISTE_GIRO_ASSOCIADO': 'There is no Giro card linked to your account.',
    'SEM_HISTORICO_PERIODO': 'No history for the selected period. Change the filter above or make a recharge.',
    'PAGUE_RECEBA_VOLTA': 'Pay and get back',
    'RECARGA_APP': 'APP Recharge - Credit -',
    'STATUS': 'Status: {0}',
    'EVENTO': 'Event -',
    'PASSAGEM_UTILIZADA': 'Ticket used - ',
    'ADICIONAR_CARTAO_GIRO': 'add new Giro card',
    'ADICIONAR_CARTAO': 'add new card',
    'GIRO_BLOQUEADO': 'Your GIRO has been successfully blocked.',
    'GIRO_BLOQUEADO_TEXTO_1': 'You have a balance of R${0}.',
    'GIRO_BLOQUEADO_TEXTO_2': 'Click on add new card to transfer the balance',
    'BLOQUEAR_CARTAO_GIRO': 'block Giro card',
    'MEU_CARTAO_GIRO': 'my Giro card',
    'PARA_EFETIVAR_TRANSFERENCIA': 'To complete your balance transfer, we need some information, take photos of the requested data.',
    'SELECIONE_FOTO_GIRO': 'select a photo of the back of the Giro',
    'SELECIONE_FOTO_DOCUMENTO': 'select a photo of your ID with CPF/Passport',
    'DESEJA_BLOQUEAR_GIRO': 'Are you sure you want to block your Giro?',
    'DESEJA_BLOQUEAR_GIRO_TEXTO_1': 'This card cannot be unblocked.',
    'DESEJA_BLOQUEAR_GIRO_TEXTO_2': 'You can transfer your balance by registering a new Giro.',
    'REMOVER': 'remove',
    'MINHA_CARTEIRA': 'my wallet',
    'DESEJA_REMOVER_CARTAO': 'Do you really want to remove the card?',
    'DESEJA_REMOVER_CARTAO_INFO': 'Once removed, you can add it again whenever you want',
    'CARTAO_REMOVIDO': 'Your card has been removed!',
    'ADICIONAR_CARTAO_PAGAMENTO': 'Add payment card',
    'REMOVER_ANEXO': 'remove attachment',
    'ENVIAR_ANEXO': 'send attachment',
    'VALOR_MAXIMO_RECARGA': 'Maximum recharge amount is {0}',
    'REAJUSTE_TARIFA': 'FARE ADJUSTMENT',
    'REAJUSTE_APARTIR': 'Starting on {0}, the ticket price will be R{1}',
    'CUPOM_INVALIDO': 'Invalid coupon.',
    'CASHBACK_TOTAL': 'Total Cashback',
    'LIMITE_CASHBACK': 'The cashback limit for this coupon is R$ {0}',
    'PERCENTUAL': 'Percentage',
    'CASHBACK_PAG_RECEBA': "Pay and Get Back R$ {0}",
    'CONFIRMAR_RECARGA': 'Confirm recharge?',
    'CONFIRMAR_COMPRA_BILHETES': 'Confirm ticket purchase?',
    'LIMITE_TEMPO_PIX': 'You have 1 hour to complete the payment before the Pix code expires',
    'CADASTRAR_CARTAO': 'register card',
    'DADOS_PESSOAIS': 'personal data',
    'FORM.NOME': 'Name',
    'FORM.SOBRENOME': 'Last Name',
    'FORM.CPF': 'CPF',
    'FORM.PASSAPORTE': 'Passaport',
    'FORM.TELEFONE': 'Phone',
    'FORM.DATA_NASCIMENTO': 'Date of Birth',
    'FORM.EMAIL': 'email',
    'FORM.SENHA': 'password',
    'FORM.CONFIRMAR_SENHA': 'password confirmation',
    'FORM.CONFIRMAR_EMAIL': 'confirm e-mail',
    'FORM.NR_GIRO': 'Giro number',
    'FORM.CONFIRM_NR_GIRO': 'Giro number confirmation',
    'ENDERECO': 'address',
    'UF': 'State',
    'CIDADE': 'city',
    'NUMERO': 'number',
    'COMPLEMENTO': 'complement',
    'PEDIDO_RECEBIDO': 'We received your order! After your order is approved, validate your online recharge at our stations',
    'FALE_CONOSCO': 'Contact Us',
    'NAO_ACHOU_DUVIDA': "Didn't find your question?",
    'NAO_CONCORDO_EXCLUIR_LINK': 'I disagree, I want to <a href="/excluir-conta">delete my account</a>',
    'RECEBER_VERIFICACAO_POR': 'Receive account verification code by:',
    'VALIDATIONS.ACEITE_REQUIRED': 'This acceptance is mandatory',
    'FORM.ATUALIZACAO_PAIS': 'I have authorization from my legal guardians to complete this registration',
    'FORM.ESTRANGEIRO': 'I\'m not from Brazil',
    'EXCLUSAO_CONTA': 'Delete Account',
    'MOTIVO_EXCLUIR': 'What is the main reason for deleting your GIRO MetroRio account?',
    'MOTIVO_NAO_USO': "I don't use the metro anymore",
    'MOTIVO_PROBLEMA': 'I had a problem with the service',
    'MOTIVO_OUTROS': 'Others',
    'CONTE_MAIS_SAIDA': 'Tell us a little about the reason for your departure?',
    'CARTAO_INSERIDO_SUCESSO': 'Card added successfully!',
    'CARTAO_INSERIDO_ERRO': 'Error adding card',
    'LOGIN_ERRO_AUTENTICACAO': 'Authentication Error',
    'GCARD_BLOQUEADO': 'Your card has been blocked',
    'ERRO_VALIDAR_GCARD': "Oops... we couldn't validate the status of GIRO card {0}",
    'ERRO_CONTATO_GCARD': 'An error occurred while contacting GIRO {0}',
    'GCARD_TRANSFERENCIA': "Your Giro was successfully added and your balance will be transferred within 5 days",
    'ERRO_BLOQUEAR_GCARD': 'Could not block the card at this time, please try again {0}',
    'CONTA_EXCLUIDA': 'Your account has been deleted',
    'CONTA_EXCLUIDA_MSG': 'You can continue recharging and checking your card balance only at the stations. This deletion does not prevent you from creating a new account in the future.',
    'CONTA_EXCLUIDA_ERRO': "An error occurred while trying to delete your account",
    'QRCODE_ERRO_BAIXAR_PDF': 'Could not download the ticket PDF: {0}',
    'QRCODE_DISPONIVEL': 'available',
    'QRCODE_EXPIRADO': 'expired',
    'QRCODE_PENDENTE': 'pending',
    'QRCODE_UTILIZADO': 'used',
    'QRCODE_COMPRA_NAO_REALIZADA': "Ticket purchase not completed",
    'TEM_CERTEZA_EXCLUIR': 'Are you sure you want to delete your account?',
    'TEM_CERTEZA_EXCLUIR_TEXTO_1': 'If you proceed, your personal data will be deleted and cannot be consulted later. You will also no longer be able to recharge or check your card balance through the Giro MetroRio app or website, nor enjoy promotional actions linked to digital recharges.',
    'TEM_CERTEZA_EXCLUIR_TEXTO_2': 'You will still be able to recharge and check your card balance at the stations. This deletion does not prevent you from creating a new account in the future.',
    'EXCLUIR_CONTA': 'delete account',
    'CONTINUAR_RECARREGANDO': 'continue recharging here',
    'QUERO_RECEBER_PROMOCOES': 'I want to receive MetroRio promotions and news by email',
    'QRCODE_TITULO': 'New Year\'s Eve Pass 2026',
    'QRCODE_COMPRAR_BILHETE': '+ buy',
    'QRCODE_LIMITE': 'Limit of 10 tickets per purchase.',
    'QRCODE_ORIENTACOES': 'Before purchasing, visit the New Year\'s Eve Special Operation page to review the boarding rules.',
    'QRCODE_ACESSAR_BILHETES': 'access purchased passes',
    'QRCODE_SABER_MAIS': 'learn more about {0}',
    'QRCODE_ABRIR_BILHETE': 'Tap the QR code to open it',
    'QRCODE_NENHUM_BILHETE_COMPRADO': 'No tickets purchased',
    'QRCODE_ESCOLHA_BILHETE': 'Choose your pass',
    'QRCODE_ESGOTADO': 'sold out',
    'QRCODE_NENHUM_BILHETE_DISPONIVEL': 'No tickets available for sale',
    'QRCODE_PERMITIDO_BILHETES': 'Only the purchase of up to 10 tickets at a time is allowed.',
    'QRCODE_IR_PAGAMENTO': 'go to payment',
    'QRCODE_BAIXAR_PDF': 'download pdf',
    'QRCODE_FORMA_PAGAMENTO': 'Choose payment method',
    'QUANTIDADE': 'quantity',
    'QRCODE_SELECIONE_ESTACOES': 'Select stations',
    'ORIGEM': 'Origin',
    'DESTINO': 'Destination',
    'REVISAR_COMPRA': 'review purchase',
    'FINALIZAR_COMPRA': 'Complete purchase',
    'NR_BILHETES': 'No. of tickets',
    'QRCODE_VALOR_POR_EMBARQUE': 'Amounting to {0} per boarding',
    'QRCODE_COMPRA_SOLICITADA': 'Ticket purchase requested',
    'CONFIRMACAO_RECARGA': 'Recharge confirmation',
    'ERROR.RETORNO_SERVIDOR': "Error in server data return. Check your internet connection.",
    'SENHA_ALTERADA': "Password Changed Successfully",
    'VALIDATIONS.FORMA_RECEBER_REQUIRED': 'Select a way to receive the verification code',
    'VALIDATIONS.REQUIRED_FIELD': 'Required field',
    'VALIDATIONS.GIRO_INVALIDO': 'The value does not match the Giro number field',
    'VALIDATIONS.EMAIL_REQUIRED': 'Email is Required',
    'VALIDATIONS.EMAIL_INVALID': 'Invalid email',
    'VALIDATIONS.USERNAME_REQUIRED': 'Username is Required',
    'VALIDATIONS.CPF_INVALID': 'This CPF is invalid',
    'VALIDATIONS.SENHA_REQUIRED': 'Password is Required',
    'VALIDATIONS.SENHA_RULES': 'Password must have at least 8 characters, numbers and one uppercase letter',
    'VALIDATIONS.RECARGA_CARTAO_OBRIGATORIO': 'To make recharges, you need to register a payment card. Go to the my data screen.',
    'VALIDATIONS.RECARGA_GIRO_OBRIGATORIO': 'To make a recharge, please register a Giro card. Go to the my data screen.',
    'VALIDATIONS.SEM_PRECO_PASSAGEM': 'No ticket price',
    'VALIDATIONS.ESCOLHA_CARTAO_PAGAMENTO': 'Choose a payment card',
    'VALIDATIONS.SELECIONE_QTD_PASSAGENS': 'Select a number of tickets or the Recharge amount',
    'VALIDATIONS.CONFIRM_SENHA_INVALID': 'The value does not match the password field',
    'VALIDATIONS.CONFIRM_EMAIL_INVALID': 'The value does not match the email field',
    'VALIDATIONS.MOTIVO_REQUIRED': 'The main reason must be filled to continue.',
    'VALIDATIONS.TERMOS_REQUIRED': 'To proceed you must accept the terms and privacy statement',
    'VALIDATIONS.FORMAT_DATA': 'The date must be entered in the format: dd/mm/yyyy',
    'VALIDATIONS.NAO_PODE_MENOR': 'Cannot create an account if under 16 years old'
}

export default TextStrings;